/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
import '../resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "UpdateCatalogImageRequest": {
                        "fields": {
                          "idempotencyKey": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "imageId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpdateCatalogImageResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "image": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateCatalogImageRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateCatalogImageResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateCatalogImageRequest @ squareup/connect/v2/catalog/interfaces/update-catalog-image.proto at 19:1
 */
export const UpdateCatalogImageRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateCatalogImageRequest');
fixType(UpdateCatalogImageRequest, {
  idempotencyKey: {
    required: true,
    notEmpty: true
  },
  imageId: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateCatalogImageRequest);
/**
 * SOURCE UpdateCatalogImageResponse @ squareup/connect/v2/catalog/interfaces/update-catalog-image.proto at 43:1
 */
export const UpdateCatalogImageResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateCatalogImageResponse');
fixType(UpdateCatalogImageResponse);
Builder.createAndAttachToType(UpdateCatalogImageResponse);